// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"501":"cbf6a17b","601":"69617972","787":"d34a764a"}[chunkId] + ".chunk.css";
};